import { useState } from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import DialogLayout from '../common/dialog-layout';

function TransactionTypeDialog({ open, onSave, onClose ,onCloseIcon }) {
  const [transactionType, setTransactionType] = useState('');

  const handleSave = () => {
    if (transactionType) {
      onSave(transactionType);
    }
  };

  const handleChange = (event) => {
    setTransactionType(event.target.value);
  };

  const content = (
    <div>
      <div className='text-2xl font-semibold text-gray-800 mb-2'>Choose the Transaction Type</div>
      <div className='text-gray-600 mb-8'>Choose the correct transaction type to move on to the form.</div>

      <div>
        <FormControl fullWidth>
          <InputLabel id="transaction-type-label">Transaction Type</InputLabel>
          <Select
            labelId="transaction-type-label"
            label="Transaction Type"
            value={transactionType}
            onChange={handleChange}
          >
            <MenuItem value="Purchase">Purchase</MenuItem>
            <MenuItem value="Refinance">Refinance</MenuItem>
          </Select>
        </FormControl>
      </div>
    </div>
  )

  const footerProps = {
    primaryButton: {
      text: "Save",
      width: '95px',
      height: '50px',
      isDisabled: !transactionType
    },
    secondaryButton: {
      text: "Cancel",
      width: '95px',
      height: '50px',
    }
  }

  return (
    <DialogLayout
      title={"Transaction Type"}
      open={open}
      fullScreen={false}
      maxWidth="670px"
      content={content}
      onClose={onClose}
      onCloseIcon={onCloseIcon}
      onSubmit={handleSave}
      footerProps={footerProps}
    />
  );
}

export default TransactionTypeDialog;
